import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../utils/Api";

const animatedComponents = makeAnimated();
const initial_value = {
  is_org: false,
  selected_org: {},
  brand_name: "",
};

export default function CreateBrand(props) {
  const [selected_type, SetSelectedType] = useState(null);
  const [save_data, SetSaveData] = useState(initial_value);
  const [organization_data, SetOrganizationData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("CreateBrand On mount :", props);
    get_init();
  }, []);

  async function get_init() {
    let response = await api("/account/signup_init");
    console.log("signup_init :", response);
    SetOrganizationData(response.response.organization);
  }

  async function create_brand() {
    console.log("Create Brand Save Data :", save_data);
    let post_value = {
      name: save_data.brand_name,
    };
    if (save_data.is_org) {
      post_value.organization = save_data.selected_org.value;
    }
    let pass_data = {
      post: post_value,
    };
    console.log("pass_data :", pass_data);
    let response = await api("/account/signup", pass_data);
    console.log("/account/signup post response :", response);
    if (response.status_code == 201) {
      let view_data_value = {
        name: save_data.brand_name,
        brand_name: "",
        type: "brand",
      };
      localStorage.setItem("view_data", JSON.stringify(view_data_value));
      SetSaveData(initial_value);
      navigate("/brand/" + response.response.id);
    }
  }

  return (
    <div>
      <div>
        {/* navbar-custom */}
        <nav className="navbar navbar-expand-lg navbar fixed-top navbar-light navbar-custom-new">
          <div className="row w-100 align-items-center">
            <div className="col-md-10">
              <h4 className="mb-0 fw-bold">Post pro</h4>
            </div>
            <div className="col-md-2 pe-0 d-lg-block d-md-none">
              <div className="sidebar-options dropdown text-right">
                <Link
                  to="/"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Home"
                >
                  <img
                    src={require("../../assets/icon/svg/home1.svg")}
                    className="header-icon-img"
                  />
                  {/* <i className="fas fa-home"></i> */}
                </Link>

                <button
                  type="button"
                  className="remove-after dropdown-toggle"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown tooltip"
                  aria-expanded="false"
                  data-bs-placement="bottom"
                  title="Notification"
                >
                  <img
                    src={require("../../assets/icon/svg/bell1.svg")}
                    className="header-icon-img"
                  />
                  {/* <i className="far fa-bell"></i> */}
                </button>
                <Link
                  to=""
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Logout"
                >
                  <img
                    src={require("../../assets/icon/svg/log-out1.svg")}
                    className="header-icon-img"
                  />
                  {/* <i className="fas fa-sign-out-alt"></i>  */}
                </Link>
                <div
                  className="nav-notification p-3 dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <div className="nav-notification-content">
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                    <a href="#" className="notification-text">
                      Nirmal Durai just sent a new comment!
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="container py-3 mt-5">
        {selected_type == null ? (
          <div>
            <div className="d-flex py-3 px-4 align-items-center mb-3">
              <Link className="cursor" to="/">
                <img
                  src={require("../../assets/icon/svg/arrow-left.svg")}
                  className="action-img pe-2"
                />
              </Link>
              <h5 className="  mb-0">Choose Account Type</h5>
            </div>
            <div className="row px-5">
              <div className="col-md-6 mb-3 ">
                <div
                  className="box-3 p-3 br-3 cursor text-center"
                  onClick={() => {
                    SetSelectedType("individual");
                  }}
                >
                  <img
                    src={require("../../assets/img/individual.svg")}
                    className="brand_create_img"
                  />
                  <h6 className="pt-4">Individual</h6>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div
                  className="box-3 p-3 br-3 cursor text-center"
                  onClick={() => {
                    SetSelectedType("organization");
                    SetSaveData((oldValues) => ({
                      ...oldValues,
                      is_org: true,
                    }));
                  }}
                >
                  <img
                    src={require("../../assets/img/organization.svg")}
                    className="brand_create_img"
                  />
                  <h6 className="pt-4">Organization</h6>
                </div>
              </div>
            </div>
          </div>
        ) : selected_type == "individual" ? (
          <div className="box-3 mt-3 p-3">
            <div className="row">
              <div className="col-md-6 mb-2">
                <img
                  src={require("../../assets/img/create.svg")}
                  className="in_create_img"
                />
              </div>
              <div className="col-md-6 mb-2">
                <div
                  className="text-end w-100 mt-3"
                  onClick={() => {
                    SetSelectedType(null);
                    SetSaveData(initial_value);
                  }}
                >
                  <p className="cursor">
                    <small className="text-blue">Change Account Type</small>
                  </p>
                </div>
                <div className="text-center w-100">
                  <img
                    src={require("../../assets/img/profile.png")}
                    className="w-25 img-radius"
                  />
                </div>
                <p className="mt-4 text-dark">Creating Account as Individual</p>

                <div className="">
                  <label className="form-label">Brand Name</label>
                  <input
                    type="text"
                    className="form-control"
                    // placeholder="Brand Name"
                    value={save_data.brand_name}
                    required
                    onChange={(e) => {
                      SetSaveData((oldValues) => ({
                        ...oldValues,
                        brand_name: e.target.value,
                      }));
                    }}
                  />
                  <div className="text-center">
                    <div
                      className="btn btn-dark-blue-outline btn-sm mt-3"
                      onClick={() => {
                        create_brand();
                      }}
                    >
                      Create Brand
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container py-3">
            {Object.keys(save_data.selected_org).length == 0 ? (
              <>
                <div className="d-flex align-items-center mt-3">
                  <div className="d-flex">
                    <div
                      onClick={() => {
                        SetSelectedType(null);
                        SetSaveData(initial_value);
                      }}
                    >
                      <img
                        src={require("../../assets/icon/svg/arrow-left.svg")}
                        className="action-img pe-2"
                      />
                    </div>
                    <h5 className="  mb-0">Organization</h5>
                  </div>
                  <div className="text-primary cursor px-3 ms-auto">
                    Create New
                  </div>
                </div>
                <div className="row justify-content-center pt-4">
                  <div className="row">
                    {organization_data.map((data, o_index) => (
                      <div className="col-md-4 mb-2">
                        <div
                          className="card p-3  cursor"
                          key={o_index}
                          onClick={(e) => {
                            SetSaveData((oldValues) => ({
                              ...oldValues,
                              selected_org: data,
                            }));
                          }}
                        >
                          <div className="row">
                            <div className="col-2">
                              {data.dp_url == null ? (
                                <img
                                  src={require("../../assets/img/profile.png")}
                                  className="w-100 img-radius mb-2"
                                />
                              ) : (
                                <img
                                  src={data.dp_url}
                                  className="w-100 img-radius mb-2"
                                />
                              )}
                            </div>
                            <div className="col-10">
                              <h6>{data.label}</h6>
                              <small>{data.user_name}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <div className="row box-3 p-3">
                <div className="col-md-6 mb-2">
                  <img
                    src={require("../../assets/img/createOrg.svg")}
                    className="in_create_img"
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <div
                    className="text-end w-100 mt-3"
                    onClick={() => {
                      // SetSaveData((oldValues) => ({
                      //   ...oldValues,
                      //   selected_org: {},
                      // }));
                      SetSelectedType(null);
                      SetSaveData(initial_value);
                    }}
                  >
                    <p className="cursor">
                      <small className="text-blue">Change Account Type</small>
                    </p>
                  </div>
                  <div className="text-center w-100">
                    <img
                      src={require("../../assets/img/profile.png")}
                      className="w-25 img-radius"
                    />
                  </div>
                  <p className="text-center v-small pt-2 pb-2">
                    {save_data.selected_org.label} -
                    <span
                      className="cursor text-blue "
                      onClick={() => {
                        SetSaveData((oldValues) => ({
                          ...oldValues,
                          selected_org: {},
                        }));
                      }}
                    >
                      change
                    </span>
                  </p>

                  <p className="mt-4 text-dark">
                    Creating Account as Organization
                  </p>

                  <div className="">
                    <label className="form-label">Brand Name</label>
                    <input
                      type="text"
                      className="form-control"
                      // placeholder="Brand Name"
                      value={save_data.brand_name}
                      required
                      onChange={(e) => {
                        SetSaveData((oldValues) => ({
                          ...oldValues,
                          brand_name: e.target.value,
                        }));
                      }}
                    />
                    <div className="text-center">
                      <div
                        className="btn btn-dark-blue-outline btn-sm mt-3"
                        onClick={() => {
                          create_brand();
                        }}
                      >
                        Create Brand
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
